import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["clubField", "guestField"]

  toggle(event) {
    const isGuest = event.target.value === "guest"
    this.clubFieldTarget.style.display = isGuest ? "none" : ""
    this.guestFieldTarget.style.display = isGuest ? "" : "none"
  }
}
